/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsSlideshowClassic = {
	init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsSlideshowClassic = $.extend(this, window.PXUTheme.getSectionData($section));

    // Selectors
    const $slideshowClassicEl = $section.find('[data-slideshow-classic]').removeClass('is-hidden');

    // Guard against double-initialization: this section now self-inits
    // (see bottom of file) as soon as its dependencies are ready, instead of
    // waiting for the theme-wide $(window).on('load', ...) sweep in app.js.
    // That sweep still runs later and will call init() again, so make sure
    // we don't hand an already-flickity-enabled element back to Flickity.
    if (!$slideshowClassicEl.hasClass('flickity-enabled')) {
      $slideshowClassicEl.flickity({
        wrapAround: true,
        adaptiveHeight: true,
        prevNextButtons: this.number_of_slides > 1 ? this.show_arrows : false,
        pageDots: this.number_of_slides > 1 ? this.show_nav_buttons : false,
        draggable: true,
        imagesLoaded: true,
        fade: this.image_transition == 'fade' ? true : false,
        autoPlay: this.image_slideshow_speed * 1000,
        arrowShape: arrowShape
      });
    }

    // Resize flickity when the slider is settled
    // $slideshowClassicEl.on( 'settle.flickity', function() {
    //   $slideshowClassicEl.flickity('resize');
    // })

  },
  blockSelect: function($section, blockId) {
    const $slider = $section.find('[data-image-slideshow]');
    const $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');

    $slider.flickity('select', $sliderIndex, true, true);

  },
	unload: function($section) {

	}
}

/******/ })()
;

// Self-init as soon as this section's dependencies (jQuery, Flickity via
// vendors.js, and window.arrowShape via app.js) are actually available,
// rather than waiting for window's 'load' event. On this page 'load' is
// gated by every resource on it -- including slow, unrelated third-party
// scripts -- which was delaying this above-the-fold slideshow's first
// Flickity activation until ~18s, well past when the hero image itself was
// ready, and that late DOM restructuring was what kept resetting LCP.
// document.currentScript only stays valid for this script's own synchronous
// top-level execution, so we capture the section element now and use it
// later inside the ready callback via closure.
(function () {
  var scriptEl = document.currentScript;
  var sectionEl = scriptEl && scriptEl.closest('.shopify-section');

  function whenReady(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  whenReady(function () {
    if (
      sectionEl &&
      window.jQuery &&
      window.PXUTheme &&
      window.PXUTheme.jsSlideshowClassic &&
      window.arrowShape
    ) {
      window.PXUTheme.jsSlideshowClassic.init(window.jQuery(sectionEl));
    }
  });
})();